exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#build-nav[data-v-1f5a26d6]{height:64px}.builder-logo[data-v-1f5a26d6]{max-height:40px}.v-toolbar--fixed[data-v-1f5a26d6]{z-index:10}.build-controls[data-v-1f5a26d6]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-width:420px}.extra-padding[data-v-1f5a26d6]{padding-left:70px}#build-nav .preview[data-v-1f5a26d6]{color:#006aff;font-weight:600;height:auto;padding-top:8px;padding-bottom:8px}.mobile-nav[data-v-1f5a26d6]{width:250px}@media (max-width:959px){.v-navigation-drawer--is-mobile[data-v-1f5a26d6],.v-navigation-drawer--temporary[data-v-1f5a26d6]{z-index:99999999}}", ""]);

// exports
